import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const PresenteTitle = styled.p`
  text-align: center;
  padding: 40px 280px;
  @media (max-width: 1500px) {
    padding: 40px 80px;
  }
  @media (max-width: 768px) {
    padding: 40px 30px;
  }
`;
export const ButtonContainer = styled.div`
  display: flex;
  gap: 18px;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;
export const ButtonPresente = styled.button`
  padding: 20px;
  border-radius: 8px;
  .botonQr-text {
    color: white;
  }
`;
